<div class="meter-header">
  <div class="title">
    <div [ngClass]="small ? 'title-text-small' : 'title-text-regular'">
      {{ title }}
    </div>
  </div>

  <div [ngClass]="small ? 'content content-small' : 'content content-regular'">
    <ng-content></ng-content>
  </div>
</div>
